import DocumentItem from 'commons/components/items/DocumentItem';
import MeetingItem from 'commons/components/items/MeetingItem';
import MeetingCard from 'commons/components/meetingcard/MeetingCard';
import NextStepCard from 'commons/components/nextstepcard/NextStepCard';
import Section from 'commons/components/section/Section';
import { isMeetingPast, statusToHubspot } from 'commons/libs/meeting_utils';
import { REQUEST_STATUSES } from 'commons/types/common';
import {
  MEETING_STATUSES,
  MeetingCardStatus,
  MeetingType,
} from 'commons/types/meetingsTypes';
import { useCallback } from 'react';
import { useDocumentList } from 'stores/documents/documentsHooks';
import { useAppDispatch, useAppSelector } from 'stores/hooks';
import { useMeetingList } from 'stores/meetings/meetingsHooks';
import { getNextMeeting } from 'stores/meetings/meetingsSlice';
import { useUser } from 'stores/user/userHooks';
import { updateUserCycleAsync } from 'stores/user/userSlice';

export default function Home() {
  const [user] = useUser();
  const dispatch = useAppDispatch();
  const [meetings, fetchMeetingsRequestStatus] = useMeetingList();
  const [documents, fetchDocumentsRequestStatus] = useDocumentList();
  const nextMeeting = useAppSelector(getNextMeeting);

  const updateStatus = useCallback(
    (status: MeetingCardStatus, type: MeetingType | undefined) => {
      dispatch(
        updateUserCycleAsync({
          patientID: user?.id || '',
          state: statusToHubspot(status, type),
        }),
      );
    },
    [dispatch, user?.id],
  );

  return (
    <div className='flex flex-col items-center grow space-y-3'>
      <NextStepCard
        updateStatus={updateStatus}
        patient={user?.patient}
        documents={documents || []}
        loading={
          fetchDocumentsRequestStatus !== REQUEST_STATUSES.SUCCESS ||
          fetchMeetingsRequestStatus !== REQUEST_STATUSES.SUCCESS
        }
        meeting={nextMeeting}
      />
      <MeetingCard
        user={user}
        meeting={nextMeeting}
      />
      <Section
        to='/documents'
        title='Mes documents'
        loading={fetchDocumentsRequestStatus === REQUEST_STATUSES.PENDING}
        childrens={
          documents?.map((document) => (
            <DocumentItem
              key={document.id}
              date={document.created}
              type={document.type}
            />
          )) || []
        }
      />
      <Section
        to='/past-schedules'
        title='Mes rendez-vous passées'
        loading={fetchMeetingsRequestStatus === REQUEST_STATUSES.PENDING}
        childrens={
          meetings
            ?.filter((meeting) => meeting.status !== MEETING_STATUSES.CANCELED)
            ?.filter((meeting) => isMeetingPast(meeting))
            .map((meeting) => (
              <MeetingItem
                key={meeting.id}
                meeting={meeting}
              />
            )) || []
        }
      />
    </div>
  );
}
